<template>
  <div>
    <el-select
      v-if="$store.state.page.style === 'dni'"
      :id="id"
      v-model="select"
      :disabled="disabled"
      @change="update"
    >
      <el-option
        v-for="(item, index) in options"
        :id="item.value"
        :key="index"
        :label="$t(item.label) || item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <select
      v-if="$store.state.page.style !== 'dni'"
      :id="id"
      v-model="select"
      :class="$store.state.page.style + '-select'"
      :disabled="disabled"
      @change="update"
    >
      <option
        v-for="(item, index) in options"
        :key="index"
        :value="item.value"
        :disabled="item.disabled == true ? true : false"
      >
        {{ $t(item.label) || item.label }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    id: {
      type: String,
      default: "",
    },
    config: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultFirstOption: {
      type: Boolean,
      default: true,
    },
    defaultPreviousSet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      select: "",
      selectIndex: -1,
    };
  },
  watch: {
    config: {
      handler() {
        this.select = this.config;
        if (this.selectIndex == -1 && this.options.length) {
          this.update();
        }
      },
      immediate: true,
    },
    options: {
      handler() {
        if (!this.defaultFirstOption) {
          return;
        }
        if (this.options.length) {
          const filter = this.options.filter((o) => {
            return o.value === this.select;
          });

          if (!filter.length) {
            if (this.defaultPreviousSet) {
              this.select = this.options[this.selectIndex].value;
              this.update();
            } else {
              this.select = this.options[0].value;
              this.update();
            }
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    update() {
      for (let i = 0; i < this.options.length; i++) {
        if (this.select == this.options[i].value) {
          this.selectIndex = i;
        }
      }
      this.$emit("update:config", this.select);
      this.$emit("change");
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
select.gui-2-1-select {
  background-color: rgba(255, 255, 255, 0.9);
  width: 100%;
  padding: $formSelectPaddingLeftRight;
  border: solid 1px #f2f2f2;
  height: 3rem;
  max-width: 500px;
  border-radius: $formInputBorderRadius;
}
select.gui-2-1-select:focus {
  outline: 1px solid #cff2ff;
  outline-offset: -1px;
}
select.gui-2-1-select:disabled {
  color: #c0c4cc;
}
.orbi.gui-2-1 {
  select.gui-2-1-select {
    height: auto;
    width: auto;
    border-color: $formBorderColor;
  }
  select.gui-2-1-select:focus {
    outline: 0;
  }
  option:disabled {
    background-color: #ccc;
    color: #7d706c;
    cursor: auto;
  }
}
</style>
